<div class="add-new-placeholder"  fxLayout="row" fxLayoutAlign="center center">
  <div fxLayout="row" fxLayoutAlign="center center">
    <mat-icon>add</mat-icon>
    <span class="add-new-text">Add your first bookmark folder</span>
  </div>
</div>
